module.exports = __webpack_public_path__ + "static/media/checkbox_hover.71ac7bab.svg";